import { render, staticRenderFns } from "./ViewSentEmailModal.vue?vue&type=template&id=c0955fb2&scoped=true"
import script from "./ViewSentEmailModal.vue?vue&type=script&lang=js"
export * from "./ViewSentEmailModal.vue?vue&type=script&lang=js"
import style0 from "./ViewSentEmailModal.vue?vue&type=style&index=0&id=c0955fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0955fb2",
  null
  
)

export default component.exports